import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./Features/api/apiSlice";
import authReducer from "./Features/states/auth-management/authSlice";
import v2PermissionsReducer from "./Features/states/auth-management/v2PermissionsSlice";
import attendanceReducer from "./Features/states/attendance/attendanceSlice";
import timesheetsReducer from "./Features/states/attendance/timesheetsSlice";
import leaveKpiReducer from "./Features/states/leave/leaveKpiSlice";
import leaveRequestsReducer from "./Features/states/leave/leaveRequestsSlice";
import departmentReducer from "./Features/states/settings/departmentSlice";
import jobTitleReducer from "./Features/states/settings/jobTitleSlice";
import attendanceSettingsReducer from "./Features/states/settings/attendanceSettingsSlice";
import leaveTypeReducer from "./Features/states/settings/leaveTypeSlice";
import permissionCatalogReducer from "./Features/states/settings/permissionCatalogSlice";
import permissionGroupsReducer from "./Features/states/settings/permissionGroupsSlice";
import companySettingsReducer from "./Features/states/settings/companySettingsSlice";
import schedulingAssignmentsReducer from "./Features/states/scheduling/schedulingAssignmentsSlice";
import shiftTemplatesReducer from "./Features/states/scheduling/shiftTemplatesSlice";
import schedulingStaffReducer from "./Features/states/scheduling/schedulingStaffSlice";
import schedulingDraftsReducer from "./Features/states/scheduling/schedulingDraftsSlice";
import payrollReducer from "./Features/states/payroll/payrollSlice";
import liveTrackingReducer from "./Features/states/live-tracking/liveTrackingSlice";
import staffReducer from "./Features/states/staff/staffSlice";
import targetReducer from "./Features/states/target/targetSlice";
import targetTemplatesReducer from "./Features/states/target/targetTemplatesSlice";
import holidaysReducer from "./Features/states/settings/holidaysSlice";
import breakAllocationReducer from "./Features/states/settings/breakAllocationSlice";
import payrollCadenceReducer from "./Features/states/settings/payrollCadenceSlice";
import settingsShiftTemplatesReducer from "./Features/states/settings/settingsShiftTemplatesSlice";
import settingsFlexibleShiftTemplatesReducer from "./Features/states/settings/settingsFlexibleShiftTemplatesSlice";
import performanceReducer from "./Features/states/performance/performanceSlice";
import staffPerformanceReducer from "./Features/states/staffPerformance/staffPerformanceSlice";
import staffSalaryReducer from "./Features/states/staffSalary/staffSalarySlice";
import staffDocumentsReducer from "./Features/states/documents/documentsSlice";
import dashboardReducer from "./Features/states/dashboard/dashboardSlice";
import portalAttendanceReducer from "./Features/states/attendance/portalAttendanceSlice";
import portalLeaveReducer from "./Features/states/leave/portalLeaveSlice";
import portalTargetReducer from "./Features/states/target/portalTargetSlice";
import portalDashboardReducer from "./Features/states/dashboard/portalDashboardSlice";
import portalDropSwapReducer from "./Features/states/scheduling/portalDropSwapSlice";
import schedulingDropSwapKpiReducer from "./Features/states/scheduling/schedulingDropSwapKpiSlice";
import recognitionHistoryReducer from "./Features/states/recognition/recognitionHistorySlice";
import portalCompanySettingsReducer from "./Features/states/settings/portalCompanySettingsSlice";
import aiChatReducer from "./Features/states/ai-agent/aiChatSlice";
import tourReducer from "./Features/states/tour/tourSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    v2Permissions: v2PermissionsReducer,
    staff: staffReducer,
    attendance: attendanceReducer,
    timesheets: timesheetsReducer,
    leaveKpi: leaveKpiReducer,
    leaveRequests: leaveRequestsReducer,
    department: departmentReducer,
    jobTitle: jobTitleReducer,
    attendanceSettings: attendanceSettingsReducer,
    leaveType: leaveTypeReducer,
    permissionCatalog: permissionCatalogReducer,
    permissionGroups: permissionGroupsReducer,
    companySettings: companySettingsReducer,
    schedulingAssignments: schedulingAssignmentsReducer,
    shiftTemplates: shiftTemplatesReducer,
    schedulingStaff: schedulingStaffReducer,
    schedulingDrafts: schedulingDraftsReducer,
    payroll: payrollReducer,
    liveTracking: liveTrackingReducer,
    target: targetReducer,
    targetTemplates: targetTemplatesReducer,
    holidays: holidaysReducer,
    breakAllocation: breakAllocationReducer,
    payrollCadence: payrollCadenceReducer,
    settingsShiftTemplates: settingsShiftTemplatesReducer,
    settingsFlexibleShiftTemplates: settingsFlexibleShiftTemplatesReducer,
    performance: performanceReducer,
    staffPerformance: staffPerformanceReducer,
    staffSalary: staffSalaryReducer,
    staffDocuments: staffDocumentsReducer,
    dashboard: dashboardReducer,
    portalAttendance: portalAttendanceReducer,
    portalLeave: portalLeaveReducer,
    portalTarget: portalTargetReducer,
    portalDashboard: portalDashboardReducer,
    portalDropSwap: portalDropSwapReducer,
    schedulingDropSwapKpi: schedulingDropSwapKpiReducer,
    recognitionHistory: recognitionHistoryReducer,
    portalCompanySettings: portalCompanySettingsReducer,
    aiChat: aiChatReducer,
    tour: tourReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
